const sectionJumperFindActive = () =>{
   // const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if(document.querySelector('.kruse-section-block--anchor-holder')){
        const holder = document.querySelector('.kruse-section-block--anchor-holder');
        const markers = holder.querySelectorAll('.kruse-section-block--anchor-holder--marker');
        const sections = document.querySelectorAll('.kruse-section-block');
        let hashes = [];
        markers.forEach(marker => {
            hashes[marker.href.split('#')[1]] = marker;


        })

        let tH = 0.1;
        const observer = new IntersectionObserver(onIntersection, {
            root: null,
            threshold: tH
        })
        let currentlyActiveSections = [];
        function onIntersection (entries, opts){
            entries.forEach(entry =>{

                if(entry.isIntersecting){

                    currentlyActiveSections.push(entry.target);
                    let isItTheBiggest = remarkMarkers(currentlyActiveSections);

                    if(isItTheBiggest == false){
                        let isIt;
                        let theInterval = setInterval(function(){
                            isIt = remarkMarkers(currentlyActiveSections);
                            if(isIt == true){

                                clearInterval(theInterval);
                            }
                        }, 100);




                    }




                }else{

                    currentlyActiveSections = currentlyActiveSections.filter(function(item){
                        return item !== entry.target;
                    });
                    hashes[entry.target.id].classList.remove('kruse-section-block--anchor-holder--marker__active');
                }

            })
        }
        sections.forEach(section => {
            observer.observe(section);
        })
        const remarkMarkers = (targetArray) => {


            let current = hashes[targetArray[targetArray.length-1].id];
            let currentSize = getViewPercentage(targetArray[targetArray.length-1]);
            let foundZero = 0;
            let biggest = current;
            if(targetArray.length > 1){
                for (let i = 0; i < targetArray.length; i++){

                    let size = getViewPercentage(targetArray[i]);

                    if(size <= 11) foundZero++;
                    if(size >= currentSize){
                        targetArray.forEach(t => {
                            hashes[t.id].classList.remove('kruse-section-block--anchor-holder--marker__active')
                        })
                        currentSize = size;
                        biggest = hashes[targetArray[i].id];
                        hashes[targetArray[i].id].classList.add('kruse-section-block--anchor-holder--marker__active')
                    }
                }
            }
            if(biggest == current){
                targetArray.forEach(t => {
                    hashes[t.id].classList.remove('kruse-section-block--anchor-holder--marker__active')
                })
                biggest.classList.add('kruse-section-block--anchor-holder--marker__active');
                if(foundZero == targetArray.length-1){

                    return true;
                }

            }
            return false;

        }
    }
    const getViewPercentage = (element) => {
        const viewport = {
            top: window.pageYOffset,
            bottom: window.pageYOffset + window.innerHeight
        };

        const elementBoundingRect = element.getBoundingClientRect();
        const elementPos = {
            top: elementBoundingRect.y + window.pageYOffset,
            bottom: elementBoundingRect.y + elementBoundingRect.height + window.pageYOffset
        };

        if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
            return 0;
        }

        // Element is fully within viewport
        if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
            return 100;
        }


        const elementHeight = elementBoundingRect.height;
        let elementHeightInView = elementHeight;

        if (elementPos.top < viewport.top) {
            elementHeightInView = elementHeight - (window.pageYOffset - elementPos.top);
        }

        if (elementPos.bottom > viewport.bottom) {
            elementHeightInView = elementHeightInView - (elementPos.bottom - viewport.bottom);
        }

        const percentageInView = (elementHeightInView / window.innerHeight) * 100;

        return Math.round(percentageInView);
    }
}

export default sectionJumperFindActive;